var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",attrs:{"id":"app"}},[_c('div',{staticClass:"main-content"},[_c('Home')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }